export const FETCH_FEES_HISTORY_ALL = "FETCH_FEES_HISTORY_ALL";
export const FETCH_FEES_HISTORY_ALL_SUCCESS = "FETCH_FEES_HISTORY_ALL_SUCCESS";
export const FETCH_FEES_HISTORY_ALL_FAIL = "FETCH_FEES_HISTORY_ALL_FAIL";
export const FETCH_FEES_HISTORY = "FETCH_FEES_HISTORY";
export const FETCH_FEES_HISTORY_SUCCESS = "FETCH_FEES_HISTORY_SUCCESS";
export const FETCH_FEES_HISTORY_FAIL = "FETCH_FEES_HISTORY_FAIL";
export const ADD_FEES_HISTORY_SUCCESS = "ADD_FEES_HISTORY_SUCCESS";
export const ADD_FEES_HISTORY_FAIL = "ADD_FEES_HISTORY_FAIL";
export const DELETE_FEES_HISTORY = "DELETE_FEES_HISTORY";
export const UPDATE_FEES_HISTORY_SUCCESS = "UPDATE_FEES_HISTORY_SUCCESS";
export const UPDATE_FEES_HISTORY_FAIL = "UPDATE_FEES_HISTORY_FAIL";